module.exports = {"headerStory":"Histoire#","storyFrom":"du vietnamien: grand-mère#"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 404
// module chunks = 168707334958949